/* eslint-disable class-methods-use-this */
import { EntityDto, PagedResultDto } from '@services';
import http from '../httpService';
import {
  CreateStatement,
  GetStatementInvoiceOptions,
  LogStatementPayment,
  PagedStatementRequest,
  SendStatement,
  Statement,
  StatementInvoice,
  UpdateStatement,
} from './dto/statement';

class StatementService {
  public async getAll(
    pagedFilterAndSortedRequest: PagedStatementRequest
  ): Promise<PagedResultDto<Statement>> {
    const result = await http.get('api/services/app/Statement/GetAll', {
      params: pagedFilterAndSortedRequest,
    });
    return result.data.result;
  }

  public async get(entityDto: EntityDto<string>): Promise<Statement> {
    const result = await http.get('api/services/app/Statement/Get', { params: entityDto });
    return result.data.result;
  }

  public async getPublicStatement(entityDto: EntityDto<string>): Promise<Statement> {
    const result = await http.get('api/services/app/Statement/GetPublic', { params: entityDto });
    return result.data.result;
  }

  public async create(statement: CreateStatement): Promise<Statement> {
    const result = await http.post('api/services/app/Statement/Create', statement);
    return result.data.result;
  }

  public async update(statement: UpdateStatement): Promise<Statement> {
    const result = await http.put('api/services/app/Statement/Update', statement);
    return result.data.result;
  }

  public async delete(entityDto: EntityDto<string>): Promise<void> {
    await http.delete('api/services/app/Statement/Delete', { params: entityDto });
  }

  public async logPayment(input: LogStatementPayment): Promise<Statement> {
    const result = await http.post('api/services/app/Statement/LogPayment', input);
    return result.data.result;
  }

  public async send(input: SendStatement): Promise<void> {
    await http.post('api/services/app/Statement/Send', input);
  }

  public async getInvoiceOptions(input: GetStatementInvoiceOptions): Promise<StatementInvoice[]> {
    const result = await http.get('api/services/app/Statement/GetInvoiceOptions', {
      params: input,
    });
    return result.data.result;
  }
}

export default new StatementService();
